import {
  AscendUSAAProgram,
  USAAParameters,
  USAAParamType,
  USAAProductDetailsModel,
  USAAProductInputModel,
  USAAPackagesInputModel,
} from './contracts';
import { programeNameValidator } from '../validators';
import { ProgramMetadataModel } from '../common';
import * as yup from 'yup';

const oneOfEnum = <T>(enumObject: { [s: string]: T } | ArrayLike<T>) =>
  yup.mixed<T>().oneOf(Object.values(enumObject));

export const usaaParametersValidator = yup.object<USAAParameters>({
  type: oneOfEnum(USAAParamType).required().label('Params Type'),
  runType: yup.string().default('').required().label('Run Type'),
  strategy: yup.string().default('').required().label('Strategy'),
  serJsonDate: yup
    .string()
    .default('')
    .required()
    .label('SER-Json File Date')
    .test({
      name: 'dateValidation',
      test(val: string) {
        if (
          val &&
          /\d{4}-\d{2}-\d{2}/.test(val) &&
          new Date(val).toString() !== 'Invalid Date'
        ) {
          return true;
        }
        return false;
      },
    }),
  executionDate: yup
    .string()
    .default('')
    .required()
    .label('Execution Date')
    .test({
      name: 'dateValidation',
      test(val: string) {
        if (
          val &&
          /\d{4}-\d{2}-\d{2}/.test(val) &&
          new Date(val).toString() !== 'Invalid Date'
        ) {
          return true;
        }
        return false;
      },
    }),
  BureauCallIndicator: yup
    .string()
    .nullable()
    .default('')
    .test({
      name: 'BureauCallIndicator',
      test(val: string) {
        const type = this.parent.type;
        if (type === USAAParamType.AccountManagement) {
          return !!val;
        }
        return true;
      },
    })
    .label('Bureau Call Indicator'),
  samplePercentage: yup
    .string()
    .default('100')
    .required()
    .label('samplePercentage'),
});

export const usaaProductDetailsValidator = yup.object<USAAProductDetailsModel>({
  userId: yup.string().default('').required(),
  programName: programeNameValidator,
  clientName: yup.string().required(),
  clientEmail: yup.string().required(),
  submitterName: yup.string().required(),
  submitterEmail: yup.string().required(),
});

export const ascendUSAAProgramValidator = yup.object<AscendUSAAProgram>({
  metadata: yup.object<ProgramMetadataModel>().required(),
  productInput: yup
    .object<USAAProductInputModel>({
      productDetails: usaaProductDetailsValidator.required(),
    })
    .required(),
  packagesInput: yup
    .object<USAAPackagesInputModel>({
      parameters: usaaParametersValidator.required(),
    })
    .required(),
});
